import ReportsToolbar from "components/toolbars/ReportsToolbar";
import Page from "design/pages/Page";
import React, { FunctionComponent, useState } from "react";
import SideBar from "design/components/toolbar/SideBar";
import StackView from "design/layouts/StackView";
import useBySymbol from "backend/hooks/elements/useBySymbol";
import useHierarchy from "backend/hooks/elements/useHierarchy";
import RowView from "design/layouts/RowView";
import CollapseCard from "design/components/cards/CollapseCard";
import TreeViewLeftPanel from "design/layouts/TreeViewLeftPanel";
import WhiteBgArea from "design/layouts/WhiteBgArea";
import useElement from "backend/hooks/elements/useElement";
import ElementTreeView from "design/components/trees/ElementTreeView";
import MeasureGridArea from "design/components/grids/MeasureGridArea";
import { ICardElementWithChildren } from "backend/model/model";
import ScopeCard from "design/components/cards/ScopeCard";
import BarSelection from "design/components/selectors/BarSelection";
import ArrowSlider from "design/components/selectors/ArrowSlider";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useLink from "@qpr/client-api-base/hooks/useLink";
import SummariesSection from "design/components/grids/SummariesSection";
import DivisionReport from "components/reporttemplates/DivisionReport";
import { useSelectedReportContext } from "state/SelectedReportContext";
import LaunchReport from "design/components/buttons/LaunchReport";
import ExportFileSelectionPopUp from "design/components/popups/ExportFileSelectionPopup";
import StrategyReport from "components/reports/StrategyReport";
import PeriodSelector from "components/PeriodSelector";
import sortHierarchy from "backend/utils/sortHierarchy";

interface ReportTemplatesProps {}
const ReportTemplates: FunctionComponent<ReportTemplatesProps> = () => {
  const ctx = useAppContext();
  const link = useLink();
  const { data: rootItem } = useElement(ctx.elementId);
  const reportSelection = useSelectedReportContext();
  const divRef = React.useRef<HTMLDivElement>(null);
  const [fileType, setFileType] = React.useState("");
  const [isExporting, setIsExporting] = React.useState(false);
  const [fileSelectAnchor, setFileSelectAnchor] =
    React.useState<HTMLDivElement | null>(null);
  /*
  const [rootItem, setRootItem] = React.useState<
    ICardElementWithChildren | undefined
  >();
*/
  const [activeTab, setActiveTab] = useState<"summaries" | "departments">(
    "summaries"
  );
  const [selectedReport, setselectedReport] = useState();
  const { data: theme } = useBySymbol("L0");
  const { data: corpo } = useElement(theme?.id);
  const { data: topElement } = useElement(rootItem?.topelement);
  const {
    data,
    isLoading: isDataLoading,
    isError,
    isPreviousData,
    isRefetching,
  } = useHierarchy(theme?.id);

  React.useEffect(() => {
    reportSelection.clearReport();
  }, [ctx.elementId]);

  const treeViewData = React.useMemo(() => {
    if (corpo && data) {
      return [
        corpo,
        ...sortHierarchy(data, (a, b) => a.symbol.localeCompare(b.symbol)),
      ];
    }
    return [];
  }, [corpo, data]);
  return (
    <Page isLoading={isDataLoading} Toolbar={ReportsToolbar}>
      <StackView gap="0px">
        <div></div>
        <RowView>
          <TreeViewLeftPanel>
            <ElementTreeView
              selectedItem={rootItem}
              items={treeViewData}
              onSelected={(item) => {
                link({ meaId: item.id });
              }}
            />
          </TreeViewLeftPanel>
          <WhiteBgArea>
            <h2>{rootItem?.name}</h2>
            <MeasureGridArea minWidth="calc(100vw - 600px )">
              {rootItem ? <DivisionReport item={rootItem} /> : null}
            </MeasureGridArea>
          </WhiteBgArea>
          <div>
            <SideBar>
              <ScopeCard
                subtitle="OK?"
                onRemove={() => {
                  reportSelection.clearReport();
                }}
                showClearBtn
                selectedReport={reportSelection.report}
              />

              {reportSelection.report ? (
                <CollapseCard title="Options" isOpen>
                  <div>
                    Select Period for the{" "}
                    {reportSelection?.report?.reportType?.name}
                  </div>
                  <PeriodSelector level="Month" />
                  <LaunchReport
                    title="Launch Report"
                    onClick={() => {
                      setFileSelectAnchor(divRef.current);
                    }}
                  />{" "}
                </CollapseCard>
              ) : null}
              <div ref={divRef} style={{ transform: "translateY(-30px)" }} />

              {fileSelectAnchor ? (
                <>
                  <ExportFileSelectionPopUp
                    onClose={() => {
                      setFileSelectAnchor(null);
                    }}
                    handleClick={(value) => {
                      setFileType(value);
                      setFileSelectAnchor(null);
                      setIsExporting(true);
                    }}
                    anchorEl={fileSelectAnchor}
                  />
                </>
              ) : null}

              {isExporting && topElement && fileType ? (
                <StrategyReport
                  item={topElement}
                  filetype={fileType!}
                  onClose={() => {
                    setIsExporting(false);
                  }}
                />
              ) : null}
            </SideBar>
          </div>
        </RowView>
      </StackView>
    </Page>
  );
};

export default ReportTemplates;

/*
    <Page isLoading={isDataLoading} Toolbar={ReportsToolbar}>
      <PageContainer>
        <SplitView right="210px" left="1fr" gap="20px">
          <StackView>
            <ReportHeader
              onChange={(val) => {
                setActiveTab(val === 1 ? "summaries" : "departments");
              }}
            />
            <div style={{ height: "20px" }}></div>
            {activeTab === "summaries" ? (
              <SummariesSection />
            ) : (
              <DepartmentsSections items={data!} />
            )}
          </StackView>
          <SideBar>
            <SimpleSearchBar
              onChange={(ev) => {
                console.log(ev);
              }}
            />
            <ScopeCard subtitle="OK?" onRemove={() => {}} showClearBtn />

            <CollapseCard title="Options">
              <h2>Quarter</h2>
              <BarSelection
                options={["Q1", "Q2", "Q3", "Q4"]}
                onChange={(selection) => {}}
              />
              <h2>Year</h2>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <ArrowSlider
                  title="2015:2030"
                  onClickLeft={() => {}}
                  onClickRight={() => {}}
                />
              </div>
            </CollapseCard>
          </SideBar>
        </SplitView>
      </PageContainer>
    </Page>
*/
